import Component from "@ember/component"
import { action, get, set } from "@ember/object"
import { later } from "@ember/runloop"
import { inject as service } from "@ember/service"
import type Router from "cc-frontend/router"
import type EmberStore from "cc-frontend/services/ember-store"
import type NotifierService from "cc-frontend/services/notifier"
import type { EmberNotification } from "cc-frontend/services/notifier"
import type Rpc from "cc-frontend/services/rpc"
import type Session from "cc-frontend/services/session"
import _ from "lodash"
import { tracked } from "tracked-built-ins"

export default class AdminSidebarCourse extends Component {
  @service("ember-store") declare store: EmberStore
  @service declare rpc: Rpc
  @service declare notifier: NotifierService
  @service declare session: Session
  @service declare router: Router

  @tracked canShowActionMenu = false

  @action makeExactCopy(courseId: string) {
    set(this, "canShowActionMenu", false)

    // Delaying this so Ember can close the menu first.
    later(() => {
      let toPlanbookId = window.prompt(
        "What planbook id should get the copy of the course (must be for same year)?"
      )
      if (toPlanbookId) {
        this.notifier.success("", {
          notificationId: `copyCourse${courseId}`,
          title: `Copying Course...`,
          message: "Live. Laugh. Love.",
          duration: 3000,
          type: "is-processing",
        })
        this.rpc
          .course_admin_exact_copy({
            courseId,
            toPlanbookId,
          })
          .then(({ responseOk, result }) => {
            if (responseOk) {
              //  @ts-ignore
              let notification: EmberNotification = _.find(get(this, "notifier.notifications"), {
                notificationId: `copyCourse${courseId}`,
              })

              if (notification) {
                set(notification, "title", "Course copied!")
                set(notification, "type", "is-success")
              }
              this.router.transitionTo("admin.course", result.newCourseId)
            } else {
              this.notifier.warning("", {
                notificationId: `copyCourse${courseId}`,
                title: `Error copying course`,
                message: "Not enough living, laughing, or loving happened.",
                duration: 3000,
                type: "is-error",
              })
            }
          })
          .catch((err) => {
            console.error("Exact copy course returned error", err)
            this.notifier.warning("", {
              notificationId: `copyCourse${courseId}`,
              title: `Error copying course`,
              message: "Not enough living, laughing, or loving happened.",
              duration: 3000,
              type: "is-error",
            })
          })
      }
    }, 150)
  }

  @action
  convertCardStackIds(courseId) {
    this.notifier.success("", {
      notificationId: `convertCardStackIds${courseId}`,
      title: `Converting cardstack ids...`,
      message: "Everything is going to be awesome...",
      duration: 60000,
      type: "is-processing",
    })

    get(this, "rpc")
      .execute("COURSE_CHANGE_CARD_STACK_CARD_IDS", courseId)
      .then(() => {
        // @ts-ignore
        let notification: EmberNotification = _.find(get(this, "notifier.notifications"), {
          notificationId: `convertCardStackIds${courseId}`,
        })
        console.log("notification inside promise", notification)
        if (notification) {
          set(notification, "title", "Converted cardstack ids!")
          set(notification, "type", "is-success")
          later(() => {
            get(this, "notifier").remove(notification)
          }, 3000)
        }
      })
    set(this, "canShowActionMenu", false)
  }
}
